import React, { FC } from 'react';

import getAdminHost from './helpers/getAdminHost';

type Props = {
    firmId: string;
};

import styles from './InternalProfileRedirect.scss';

export const InternalProfileRedirect: FC<Props> = ({ firmId }) => {
    const adminHost = getAdminHost();
    return (
        <div className={styles.wrapper}>
            {typeof window !== 'undefined' && (
                <span>
                    {`To edit this firm profile you must go to the `}
                    <a href={`${adminHost}/internal/trade/firm/${firmId}/profile/`}>
                        {'internal profile editor.'}
                    </a>
                </span>
            )}
        </div>
    );
};
